import login from './login';

export default {
  language: 'fr-FR',
  country: 'fr',
  name: 'Français',
  embeddedLocale: login,
};
